export default __webpack_public_path__ + "static/media/RequestDeskGirl.6ec86d6c.svg";